import { Timestamp } from "firebase/firestore";

// Public previews are valid for one day, then refresh on the next lookup.
// Booking uses its realtime providers.
export const LOCAL_MARKET_CACHE_TTL_MS = 24 * 60 * 60 * 1000;

// Restore the SDK values lost during JSON persistence before sharing helpers.
export const parseLocalMarketCache = (raw) =>
  JSON.parse(raw, (_key, value) =>
    value?.type === "firestore/timestamp/1.0"
      ? Timestamp.fromJSON(value)
      : value,
  );

export const hasFreshLocalMarketData = (data, now = Date.now()) => {
  const fetchedAt = Number(data?.fetchedAt);
  return (
    Number.isFinite(fetchedAt) &&
    fetchedAt > 0 &&
    fetchedAt <= now &&
    now - fetchedAt < LOCAL_MARKET_CACHE_TTL_MS
  );
};
